import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  container: props => ({
    width: props.width,
    height: props.height
  }),
  st0: {
    fill: "#cee0e9"
  },
  st1: {
    fill: "#8db8cb",
    stroke: "#5c9cb6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }
});

const ZimbabweOutlineIcon = props => {
  const classes = useStyles(props);

  return (
    <SvgIcon
      viewBox="0 0 80 80"
      className={classNames(classes.container, props.className)}
    >
      <path
        className={classes.st0}
        d="M0,0v80h80V0H0z M68.7,32.2L66.3,37v4.8h2.4v4.8L63.8,54v4.8l-9.7,9.7h-9.7l-4.8-2.4h-2.4l-2.4-4.8h-7.3
	l-2.4-4.8v-7.3h-4.8v-2.4L8.2,41.9l-2.4-9.7L3.4,25l14.5,2.4l7.3-9.7l9.7-4.8V8l4.8-2.4H47V8h7.3l14.5,7.3v16.9H68.7z"
      />
      <polygon
        className={classes.st1}
        points="68.7,32.2 68.7,15.3 54.2,8 46.9,8 46.9,5.6 39.6,5.6 34.8,8 34.8,12.9 25.1,17.7 17.9,27.4 3.4,25 
	5.8,32.2 8.2,41.9 20.3,46.7 20.3,49.1 25.1,49.1 25.1,56.4 27.6,61.2 34.8,61.2 37.2,66.1 39.6,66.1 44.5,68.5 54.2,68.5 
	63.8,58.8 63.8,54 68.7,46.7 68.7,41.9 66.2,41.9 66.2,37.1 "
      />
    </SvgIcon>
  );
};

ZimbabweOutlineIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};

export default ZimbabweOutlineIcon;
